import packageJson from '../../package.json';

const APP_VERSION = packageJson.version;
const VERSION_KEY = 'app_version';

/**
 * Checks if the stored version matches the current package version.
 * If they differ, it clears non-essential cache items and performs a hard reload.
 */
export const checkVersionAndClearCache = () => {
    const storedVersion = localStorage.getItem(VERSION_KEY);
    
    if (storedVersion !== APP_VERSION) {
        console.log(`Version change detected: ${storedVersion} -> ${APP_VERSION}. Clearing cache...`);
        
        // Items to keep (Auth info)
        const token = localStorage.getItem('token');
        const name = localStorage.getItem('name');
        const email = localStorage.getItem('email');
        const phone = localStorage.getItem('phone');
        const id = localStorage.getItem('id');
        const total = localStorage.getItem('total');
        const avatar = localStorage.getItem('avatar');
        const banner = localStorage.getItem('banner');
        
        // Clear everything
        localStorage.clear();
        
        // Restore essential items
        if (token) localStorage.setItem('token', token);
        if (name) localStorage.setItem('name', name);
        if (email) localStorage.setItem('email', email);
        if (phone) localStorage.setItem('phone', phone);
        if (id) localStorage.setItem('id', id);
        if (total) localStorage.setItem('total', total);
        if (avatar) localStorage.setItem('avatar', avatar);
        if (banner) localStorage.setItem('banner', banner);
        
        // Set new version
        localStorage.setItem(VERSION_KEY, APP_VERSION);
        
        // Force a hard reload to clear any memory state or stale assets
        // window.location.reload();
    }
};

/**
 * Forcefully clears the data cache. If an ID is provided, cancels specific project cache.
 */
export const clearDataCache = (id = null) => {
    localStorage.removeItem('data');
    localStorage.removeItem('lastProjectVisited');
    
    const prefix = id ? `project_cache_${id}` : 'project_cache_';
    const keysToRemove = [];
    
    const len = localStorage.length;
    for (let i = 0; i < len; i++) {
        const key = localStorage.key(i);
        if (key && (key.startsWith(prefix) || key.startsWith('cache_') || key.includes('data_'))) {
            keysToRemove.push(key);
        }
    }
    keysToRemove.forEach(k => localStorage.removeItem(k));
};
